import React from "react";
import Countdown from "react-countdown";

import { Box, Span } from "@catchoftheday/cg-components";

type CountdownTimerProps = {
  date: Date;
  timerLabel: string;
  maxHoursShown: number;
};

export const CountdownTimer = ({
  date,
  maxHoursShown,
  timerLabel,
}: CountdownTimerProps) => {
  const renderer = ({ formatted: { hours, minutes, seconds }, completed }) => {
    if (completed) return null;
    const hourNum = Number(hours);
    if (hourNum > maxHoursShown) {
      const daysLeft = Math.floor(hourNum / 24);
      return (
        <Box
          display="inline-block"
          color="errorDark"
          textTransform="uppercase"
          mr="0.11em"
        >
          <Span fontWeight="semibold">
            {hourNum < 24
              ? `${hourNum} hours left`
              : `${daysLeft} day${daysLeft > 1 ? "s" : ""} left`}
          </Span>
        </Box>
      );
    } else
      return (
        <Box
          display="inline-block"
          color="errorDark"
          textTransform="uppercase"
          mr="0.11em"
        >
          {timerLabel && <Span fontWeight="semibold">{timerLabel}&nbsp;</Span>}

          <Span fontFamily="Helvetica,Arial,sans-serif" fontWeight="semibold">
            {hours}:{minutes}:{seconds}
          </Span>
        </Box>
      );
  };

  return <Countdown daysInHours date={date} renderer={renderer} />;
};
